// 白いキャンバスの上になにかを置きたいときに使う
import React from "react";
import Container from "@mui/material/Container";
import Paper, { PaperProps } from "@mui/material/Paper";
import { Breakpoint, SxProps, Theme } from "@mui/material/styles";

export type NitoelPaperMaxWidth = "xs" | "sm" | "md" | "lg" | "xl" | "full";

export interface NitoelPaperProps extends Omit<PaperProps, "maxWidth"> {
  children: React.ReactNode;
  maxWidth?: NitoelPaperMaxWidth;
  elevation?: number;
  sx?: SxProps<Theme>;
}

const NitoelPaper: React.FC<NitoelPaperProps> = ({ children, maxWidth, elevation = 1, sx, ...paperProps }) => {
  const isFullWidth = maxWidth === "full";

  // maxWidthが指定されていない場合は、従来のPaperのみを返す（後方互換性）
  if (!maxWidth) {
    return (
      <Paper
        elevation={elevation}
        sx={{
          marginBottom: 2,
          padding: 2,
          ...sx,
        }}
        {...paperProps}
      >
        {children}
      </Paper>
    );
  }

  // maxWidthが指定されている場合は、Containerでラップする
  return (
    <Container
      maxWidth={isFullWidth ? false : (maxWidth as Breakpoint)}
      disableGutters={isFullWidth}
      sx={{
        ...(isFullWidth && {
          maxWidth: "100%",
          width: "100%",
        }),
      }}
    >
      <Paper
        elevation={elevation}
        sx={{
          marginBottom: 2,
          padding: 2,
          ...sx,
        }}
        {...paperProps}
      >
        {children}
      </Paper>
    </Container>
  );
};

export default NitoelPaper;
